<!--
  -  Copyright (c) Qwoach LLC 2022. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 20/10/2022
  -->

<template>
	<el-collapse-item v-bind="attrsComputed" :name="nameComputed" class="qw-collapse-item-root">
		<slot></slot>
		<template #title v-if="$slots.title">
			<div @click="onTitleClicked">
				<slot name="title"></slot>
			</div>
		</template>
	</el-collapse-item>
</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";
import {uuidv4} from "@/utils/helpers";

export default {
	name: "QwCollapseItem",
	extends: BaseComponent,
	inheritAttrs: false,

	props: {
		isExpanded: {Boolean, default: false},
		isTitleClickable: {Boolean, default: false},
	},

	inject: ['qwCollapseOnItemChange'],


	mounted() {
		if (this.qwCollapseOnItemChange) {
			this.qwCollapseOnItemChange(this.nameComputed, this.isExpanded);
		}
	},

	methods: {

		onTitleClicked(event) {
			if (!this.isTitleClickable) {
				event.stopPropagation();
			}
		},

		handleItemClick() {
			console.log("QwCollapseItem: handleItemClick = ", ...arguments)
			this.$emit("click")
		}
	},

	computed: {


		nameComputed() {
			return this.$attrs.name || this.$attrs.title || uuidv4()//this.$slots.title && getSlotChildrenText(this.$slots.title())
		},

		attrsComputed(){
			let {onChange, ...rest} = this.$attrs
			return {
				...rest,
				// handleItemClick(){
				// 	console.log("QwCollapseItem: handleItemClick = ", ...arguments)
				// },
				onChange(){
					console.log("QwCollapseItem: onChange = ", ...arguments)
					if(onChange){
						onChange()
					}
					// this.$emit("change")
				}
			}
		}
	},
}
</script>

<style lang="scss">

@import "@/styles/variables";

.qw-collapse-item-root {
	.el-collapse-item__header{
		height: auto;
		min-height: var(--el-collapse-header-height);
		line-height: 1.3em;
		text-align: left;
		padding-right: 10px;
	}

	&.hover{
		background: inherit;
		.el-collapse-item__header{
			&:hover{
				background: $hover-color;
			}
		}
	}
}

.link-title{
	color: $link-color;
	.el-collapse-item__header{
		color: inherit;
		text-decoration: none;
	}
	.el-collapse-item__header:hover{
		color: inherit;
		text-decoration:underline;
	}

}


</style>
